import type { App } from "vue"
import type { ModuleDefinition, ModuleOptions } from "@core/types/module"

const pvModule: ModuleDefinition = {
    name: "pv",

    install(_app: App, _options: ModuleOptions): void {
        // Pinia : usePvStore() à la demande dans les pages
    },
}

export default pvModule
